/** What waits on the person, and how each reason is said. Client-safe: no database imports. */
export type NeedsYouReason = "version" | "instructions" | "resources";

export const NEEDS_YOU_LABEL: Record<NeedsYouReason, string> = {
  version: "A new version waits for you to rebuild, test or approve it",
  instructions: "A proposed change to the instructions waits for your approval",
  resources: "An open resource request waits for your answer",
};
